import {getCountryCodeAndNameFromValue} from '@services/properties/getLeadGenerationOptions';
import {getLocalStorage, setLocalStorage} from './localstorage.utilts';

type FormDataType = Record<string, any>;

export const FORM_DATA_CACHE_KEY = 'FORM_DATA_CACHE_KEY';

export function getFormDataCache(
  defaultForm: FormDataType,
  returnAll?: boolean
): FormDataType {
  const cachedData = getLocalStorage(FORM_DATA_CACHE_KEY);
  if (!cachedData) return defaultForm;
  if (cachedData.countryCode && defaultForm.countryCode) {
    //this is to updated cached form data(countryCode key) into new version
    const {name} = getCountryCodeAndNameFromValue(cachedData.countryCode);
    if (!name) {
      cachedData.countryCode = defaultForm.countryCode;
      cachedData.country = defaultForm.country;
    }
  }
  if (returnAll) return cachedData;
  const requiredKeys = Object.entries(defaultForm).map(([key]) => key);
  const requiredCacheData = Object.fromEntries(
    requiredKeys.map((key) =>
      cachedData[key] ? [key, cachedData[key]] : [key, defaultForm[key]]
    )
  );
  return requiredCacheData;
}

export function setFormDataCache(formData: FormDataType) {
  const prevFormData = getFormDataCache({}, true);
  setLocalStorage(FORM_DATA_CACHE_KEY, {...prevFormData, ...formData});
}
